var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-with-content"},[_c('p',{staticClass:"bold-text"},[_vm._v(" "+_vm._s(_vm.title)+": "),_c('span',{staticClass:"thin-text"},[_vm._v(_vm._s(_vm.items))])])])}
var staticRenderFns = []

export { render, staticRenderFns }